export default __webpack_public_path__ + "static/media/ads_five_bg.57138b3a.jpg";